"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageLevelSelectField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const LanguageLevelSelect_1 = require("../../global/LanguageLevelSelect");
const LanguageLevelSelectField = (props) => {
    const { name, listName, label, rules, ...otherProps } = props;
    const hasListName = typeof listName === 'number' || typeof listName === 'string';
    const fieldName = hasListName ? [listName, name] : name;
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: fieldName, label: label, rules: rules, children: (0, jsx_runtime_1.jsx)(LanguageLevelSelect_1.LanguageLevelSelect, { ...otherProps }) }));
};
exports.LanguageLevelSelectField = LanguageLevelSelectField;
